<template>
  <expansion-panel
    key="expansion-panel-customer-notes"
    :title="$t('offer-manager.create.step-delivered-vehicle.title')"
    :readonly="panelReadonly"
    :hideDivider="panelHideDivider">
    <template v-slot:panel-content>
      <m-form-row :label="$t('offer-manager.create.step-delivered-vehicle.lbl-brand')">
        <mapit-input
          uid="deliveredVehicleBrand"
          :value="deliveredBrand"
          :placeholder="$t('offer-manager.create.step-delivered-vehicle.lbl-brand')"
          @changeValue="value => updateOffer('setDeliveredBrand', value)"
          :rules="deliveredVehicleRules"
          :clearable="true"
          :hideDetails="true"
          :maxlength="100"
          :disabled="disabled" />
      </m-form-row>
      <m-form-row :label="$t('offer-manager.create.step-delivered-vehicle.lbl-model')" class="mt-2">
        <mapit-input
          uid="deliveredVehicleModel"
          :value="deliveredModel"
          :placeholder="$t('offer-manager.create.step-delivered-vehicle.lbl-model')"
          @changeValue="value => updateOffer('setDeliveredModel', value)"
          :rules="deliveredVehicleRules"
          :clearable="true"
          :hideDetails="true"
          :maxlength="100"
          :disabled="disabled" />
      </m-form-row>
      <m-form-row :label="$t('offer-manager.create.step-delivered-vehicle.lbl-import')" class="mt-2">
        <mapit-input
          uid="deliveredVehicleImport"
          :value="deliveredAmount"
          :type="InputTypes.PRICE"
          :forceFloat="true"
          :placeholder="$t('offer-manager.create.step-delivered-vehicle.lbl-import')"
          @changeValue="value => updateOffer('setDeliveredAmount', value)"
          :rules="deliveredVehicleRules"
          :hideDetails="true"
          :disabled="disabled" />
      </m-form-row>
      <div v-if="!validDeliveredBike" class="d-flex justify-end color-red fs-14">
        <span class="text-right pl-2 pr-6">{{ $t('offer-manager.create.step-delivered-vehicle.lbl-error') }}</span>
      </div>
    </template>
  </expansion-panel>
</template>

<script lang="ts">
import {computed, defineComponent} from '@vue/composition-api'

import ExpansionPanel from '@/components/general/ExpansionPanel.vue'
import MapitInput from '@/components/general/MapitInput.vue'
import {InputTypes} from '@/utils/constants'
import {mapGetters} from '@/utils/map-store'

export default defineComponent({
  name: 'DeliveredVehicle',
  components: {ExpansionPanel, MapitInput},
  props: {
    panelReadonly: {
      type: Boolean,
      default: false,
    },
    panelHideDivider: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {root, emit}) {
    const {
      getDeliveredBrand: deliveredBrand,
      getDeliveredModel: deliveredModel,
      getDeliveredAmount: deliveredAmount,
    } = mapGetters(root.$store.getters)

    const deliveredVehicleRules = computed(() => [
      () =>
        (deliveredBrand.value && deliveredModel.value && deliveredAmount.value) ||
        (!deliveredBrand.value && !deliveredModel.value && !deliveredAmount.value) ||
        'Error rules',
    ])

    const validDeliveredBike = computed(
      () =>
        (deliveredBrand.value && deliveredModel.value && deliveredAmount.value) ||
        (!deliveredBrand.value && !deliveredModel.value && !deliveredAmount.value),
    )

    function updateOffer(action: string, value: any) {
      root.$store.dispatch(action, value)
      emit('validateForm')
    }

    return {
      InputTypes,
      deliveredVehicleRules,
      validDeliveredBike,
      deliveredBrand,
      deliveredModel,
      deliveredAmount,
      updateOffer,
    }
  },
})
</script>
<style lang="scss">
.fs-14 {
  font-size: 14px;
}
</style>
